(function() {
    var unfoldClamp = '200';
    SR.dom.$body.on('click', '.J_foldContentSimply', function() {
        var $me = $(this);
        var $content = $me.find('.fold-content');
        var $tip = $me.find('.tip');
        var historyClamp = $me.attr('data-clamp');
        var currentStatus;
        var foldTag = 'has-fold';
        var nextClamp;
        if (!historyClamp) {
            historyClamp = $content.css('-webkit-line-clamp');
            $me.attr('data-clamp', historyClamp);
        }
        currentStatus = $content.css('-webkit-line-clamp') !== unfoldClamp ? 'fold' : 'unfold';
        if (currentStatus === 'fold') {
            // 展开
            nextClamp = unfoldClamp;
            $tip.text('收起').addClass(foldTag);
        } else {
            // 收起
            nextClamp = historyClamp;
            $tip.text('展开').removeClass(foldTag);
        }
        $content.css({
            '-webkit-line-clamp': nextClamp
        });
    });
})();